import { render, staticRenderFns } from "./emailRecord.vue?vue&type=template&id=2972a78d&scoped=true&"
import script from "./emailRecord.vue?vue&type=script&lang=js&"
export * from "./emailRecord.vue?vue&type=script&lang=js&"
import style0 from "./emailRecord.vue?vue&type=style&index=0&id=2972a78d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972a78d",
  null
  
)

export default component.exports